"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var styles=require("@material-ui/core/styles");let r=styles.makeStyles(e=>({tagText:{backgroundColor:e=>e.backgroundColor,borderRadius:3,color:e=>e.color,fontSize:12,padding:e.spacing(.5,1)}}));exports.default=r;
//# sourceMappingURL=styles.js.map
